// ChannelRow — a channel is a PLACE (spec §1 / §3).
//
// Persistent, scrollable, never resolved, never assigned. A plain row — not a
// <SituationCard>; SituationCard is for work rows (threads). The channel reads
// like a channel: name, last activity, message count. Client-facing is a
// permanent coloured left border + label — someone about to type needs to know
// the client can see it BEFORE they type. Quiet channels are hidden by the rail
// unless "show quiet" is on (90 days silent), so this row renders only when it
// is NOT quiet or quiet was explicitly requested.
import React from "react";
import { formatWhen, fmtNumber } from "../../shared/format";

const CLIENT_BORDER = "border-l-4 border-l-[#32B1FF]";

/**
 * @param {object} props
 * @param {object} props.channel   { id, name, client, client_facing, company_key, threads, messages, last_at }
 * @param {boolean} props.selected
 * @param {(id: string) => void} props.onSelect
 */
export default function ChannelRow({ channel, selected, onSelect }) {
  const c = channel || {};
  return (
    <button
      type="button"
      data-testid="channel-row"
      data-channel-id={c.id}
      aria-current={selected ? "page" : undefined}
      onClick={() => onSelect(c.id)}
      className={`flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm transition-colors ${
        c.client_facing ? CLIENT_BORDER : "border-l-4 border-l-transparent"
      } ${
        selected
          ? "bg-[#32B1FF]/10 text-gray-900 dark:text-gray-100"
          : "text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"
      }`}
    >
      <span className="truncate font-medium">#{c.name || "channel"}</span>
      {c.client_facing && (
        <span className="shrink-0 rounded bg-[#32B1FF]/10 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-[#32B1FF]">
          Client
        </span>
      )}
      <span className="ml-auto flex shrink-0 items-center gap-2 text-xs text-gray-400">
        {typeof c.messages === "number" && (
          <span className="tabular-nums">{fmtNumber(c.messages)}</span>
        )}
        {c.last_at && <span className="tabular-nums">{formatWhen(c.last_at)}</span>}
      </span>
    </button>
  );
}
